import React, { useState } from 'react';
import BaseFormField from '../base-form-field';
import { AddFunnelPropFromContext } from '../funnel-context';
import Modal from '@nib-components/modal';
import { Margin, px } from '@nib/layout';
import styled from 'styled-components';
import { SecondaryButton } from '@nib-components/button';
import Link from '@nib-components/link';
import Copy from '@nib-components/copy';
import RadioGroup from '@nib-components/radio-group';
import { FUNNELS, LABELS as DEFAULT_LABELS } from '../../util/constants';
import { defaultFieldPropTypes } from '../../types';
import { colorLightest, colorTrueGreen } from '@nib-components/theme';
const LABELS = {
  ARHI: DEFAULT_LABELS.HOSPITAL_EXCESS
};
const SectionContainer = styled.div`
  ${px(5)};
`;
const StyledDiv = styled.div`
  display: inline-block;
  padding: 16px;
  padding-bottom: 16px;
  background-color: ${colorLightest};
  color: ${colorTrueGreen};
  text-align: center;
  border-style: solid;
  width: 50px;
  height: 20px;
`;
const Wrapper = styled.div`
  display: inline-block;
`;
const HospitalExcess = props => {
  const {
    funnel = FUNNELS.ARHI,
    help = '',
    width = 20,
    optional = false,
    options = {
      0: '0',
      500: '500'
    },
    excessModal = React.createElement(HospitalExcessModal, null),
    showRadioOptions = true
  } = props;
  // We should only show the radio options when there is more than one option
  return React.createElement(React.Fragment, null, React.createElement(SectionContainer, null, showRadioOptions ? React.createElement(BaseFormField, {
    ...props,
    label: props.label || LABELS[funnel] || LABELS.ARHI,
    funnel: funnel,
    width: width,
    help: help,
    optional: optional
  }, React.createElement(RadioGroup, {
    inline: props.inline,
    options: options,
    formMode: props.formMode
  })) : React.createElement(Wrapper, null, React.createElement(BaseFormField, {
    ...props,
    label: props.label || LABELS[funnel] || LABELS.ARHI,
    funnel: funnel,
    width: width,
    help: help,
    optional: optional
  }, React.createElement(StyledDiv, null, React.createElement(Copy, {
    align: "center",
    color: "darkest"
  }, Object.values(options)[0])))), React.createElement(Margin, {
    top: 4
  }, excessModal)));
};
const HospitalExcessWithFunnel = props => React.createElement(AddFunnelPropFromContext, null, React.createElement(HospitalExcess, {
  ...props
}));
export default HospitalExcessWithFunnel;
export const HospitalExcessModal = () => {
  const [isVisible, setIsVisible] = useState(false);
  const handleOpenModal = () => {
    setIsVisible(true);
  };
  const handleCloseModal = () => {
    setIsVisible(false);
  };
  return React.createElement(React.Fragment, null, React.createElement(Link, {
    component: "button",
    type: "button",
    onClick: handleOpenModal
  }, "What is an excess?"), React.createElement(Modal, {
    title: "What is an excess?",
    visible: isVisible,
    onClose: handleCloseModal
  }, React.createElement(Margin, {
    bottom: 4
  }, React.createElement(Copy, null, "Just like with a car or home insurance, an excess is a contribution you're required to pay towards a hospital claim you make on your policy. It's paid directly to the hospital when you're admitted for treatment.")), React.createElement(Margin, {
    bottom: 6
  }, React.createElement(Copy, null, "Having an excess on your hospital cover is a way of making your health insurance cheaper. Generally, the greater excess you choose, the lower your premiums will be.")), React.createElement(SecondaryButton, {
    onClick: handleCloseModal
  }, "Close")));
};
HospitalExcess.defaultProps = {
  ...defaultFieldPropTypes,
  options: {
    0: '0',
    500: '500'
  }
};